import { Injectable, EventEmitter } from '@angular/core';
import {  Resource } from '../../_models/index';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResoursesService {

  data: Resource[] = [];
  
  constructor() {
   
  }
  public ChangeNotefier  = new EventEmitter();

  getall(): Resource[] {

    return this.data;
  }
  getById(id :number): Resource {

    return this.data.find(f=>f.id ==id);
  }

  count() :number{
    if(this.data)
    return this.data.length;
    else
    return 0;
  }
  
  insertResource (item :Resource){
    this.data.push(item);
    this.ChangeNotefier.emit(this.data);
  }

  removeResource(item : Resource)
  {
    let i =  this.data.findIndex(f=>f.id ==item.id);
    if(i>-1)
    {
      this.data.splice(i,1);
      this.ChangeNotefier.emit(this.data);
    }
  }
  
  updateResource(id :number ,item:Resource){
    let i= this.data.findIndex(f=>f.id ==id);
    if(i>-1)
    {
    this.data[i]= JSON.parse(JSON.stringify(item));
    this.ChangeNotefier.emit(this.data);
    }
  }

  getIconByType(item :Resource ){

      if(item.file.type.endsWith("pdf"))
      {
        return "/assets/Icons/ic-pdf.png"
      }
      else if(item.file.type ==("doc") || item.file.type ==("docx") )
      {
        return "/assets/Icons/ic-doc.png"
      }
      else if(item.file.type==("zip") )
      {
        return "/assets/Icons/ic-zip.png"
      }
      else if(item.file.type == ("png")|| item.file.type ==("jpg") )
      {
        return "/assets/Icons/ic-jpg.png"
      }
      else{
        return "/assets/Icons/ic-zip.png"
      }

  }


}

